//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import resolveUrl from '../mixins/resolve-url';

export default {
	name: 'groups-logo',
	mixins: [resolveUrl],
	computed: {
		href() {
			return this.resolveUrl('/');
		}
	}
};
